/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */

/**
 * How wide each bucket of the activity trend is. Note that the first and last buckets may be smaller than the requested granularity if the requested range does not align with the granularity.
 */
export type ActivityTrendGranularity =
    (typeof ActivityTrendGranularity)[keyof typeof ActivityTrendGranularity];

export const ActivityTrendGranularity = {
    daily: "daily",
    weekly: "weekly",
    monthly: "monthly",
    quarterly: "quarterly",
    yearly: "yearly",
} as const;
